import {
  addDays,
  addHours,
  addMinutes,
  addMonths,
  format,
  isBefore,
  parse,
  parseISO,
} from "date-fns";
import { ko } from "date-fns/locale";

// date를 원하는 포멧으로 변경함.
export const dateToFormat = (date: Date, strFormat: string): string => {
  return format(date, strFormat, { locale: ko });
};

// string형태의 date를 원하는 포맷으로 변경하여 리턴
export const strToFormat = (strDate: string, strFormat: string): string => {
  try {
    return format(parseISO(strDate), strFormat, { locale: ko });
  } catch {
    return "";
  }
};

// 날짜 스트링을 현지시간으로 변경함.
export const strToDate = (date: string, strFormat: string): Date => {
  return parse(date, strFormat, new Date());
};

// 날짜에 분을 더함
export const getAddMinute = (date: Date, minute: number): Date => {
  return addMinutes(date, minute);
};

// 날짜에 시간을 더함
export const getAddHour = (date: Date, hour: number): Date => {
  return addHours(date, hour);
};

// 날짜에 일자를 더함.
export const getAddDay = (date: Date, day: number) => {
  return addDays(date, day);
};

// 날짜에 달을 더함.(date포멧)
export const getAddMonthsDate = (date: Date, month: number) => {
  return addMonths(date, month);
};

// 밀리초를 시:분:초 형식으로 변환
export const formatTime = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    "0",
  );
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

// 해당 날짜가 지금 시간보다 이전인지 여부 체크 (오늘은 제외)
export const isBeforeTodayIgnoreToday = (strDate: string): boolean => {
  try {
    // 시간까지 리셋하기 위해서 strToFormat 추가함 (이벤드 endDt 시간때문에 잘못 체크 됨)
    return isBefore(
      new Date(strToFormat(strDate || "", "yyyy-MM-dd")),
      getAddDay(new Date(), -1),
    );
  } catch {
    return false;
  }
};
